module.exports = __webpack_public_path__ + "img/fenlei.cffef938.jpg";